<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">Your payout request has been successfully submitted!</div>
          <div class="desc">You can track the status of your payout in your account.</div>
          <div class="buttons" style="margin-top: 24px; display: flex; gap: 12px; flex-wrap: wrap;">
            <button class="button" @click="goToOffers">
              <span>View My Offers</span>
            </button>
            <button class="button orange-btn" @click="goHome">
              <span>Return to Home</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'SuccessPayoutPage',
  methods: {
    goToOffers() {
      this.$router.push({ name: 'Profile', query: { tab: 'my-offers' } })
    },
    goHome() {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style scoped>
</style>
